module.exports = "../static/images/bc37c9.png";